import { Box } from '@amzn/ring-ui-react-components';
import { useTranslation } from 'react-i18next';
import {
  PostingDescription,
  PostingTitle,
} from 'src/components/Posting/components';

interface Props {
  limit: number;
}

export const Header = (props: Props) => {
  const { t } = useTranslation('components.posting');
  const { limit } = props;
  return (
    <Box p={{ base: 6, m: 0 }}>
      <PostingTitle>{t('ring-history.title')}</PostingTitle>
      <PostingDescription mb={{ base: 0, m: 7 }}>
        {t('ring-history.description', { limit })}
      </PostingDescription>
    </Box>
  );
};
